import React, { Component } from 'react';
import './style.sass';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
import CommonSmallText from '../../../common-components/common-small-text';

const list = [
    {
        showDataTitle: '7',
        showDataSubtitle: 'сложных интеграций, внедренных за&nbsp;весь период работы',
    },
    {
        showDataTitle: '120&nbsp;000',
        showDataSubtitle: 'пользовательских&nbsp;ID перенесли в&nbsp;рамках одной интеграции',
    },
    {
        showDataTitle: '18&nbsp;740',
        showDataSubtitle: 'заявок на&nbsp;поступление было получено с&nbsp;января 2020 года',
    },
    {
        showDataTitle: '445',
        showDataSubtitle: 'детей поступили в&nbsp;школу по&nbsp;результатам заполненных заявок',
    },
];

class Digits extends Component {
    render() {
        return (
            <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1.5}>
                <FullWrapper className="letovo-digits" smallPaddings={true}>
                    <CommonTitle>Цифры</CommonTitle>
                    <ScrollAnimation
                        animateIn="fadeIn"
                        offset={100}
                        animateOnce={true}
                        duration={1.5}
                    >
                        <div className="letovo-digits-ciphers">
                            <div className="letovo-digits-ciphers__wrapper">
                                <div className="letovo-digits-ciphers__grid">
                                    {list.map(({ showDataTitle, showDataSubtitle }, index) => (
                                        <ScrollAnimation
                                            animateIn="fadeInUp"
                                            offset={0}
                                            delay={100}
                                            animateOnce={true}
                                            duration={1}
                                            className="letovo-digits-ciphers__item"
                                            key={index}
                                        >
                                            <div className="letovo-digits-ciphers__item-wrap">
                                                <div
                                                    className="letovo-digits-ciphers__name"
                                                    dangerouslySetInnerHTML={{
                                                        __html: showDataTitle,
                                                    }}
                                                ></div>
                                                <CommonSmallText className="letovo-digits-ciphers__desc">
                                                    <p
                                                        dangerouslySetInnerHTML={{
                                                            __html: showDataSubtitle,
                                                        }}
                                                    ></p>
                                                </CommonSmallText>
                                            </div>
                                        </ScrollAnimation>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </ScrollAnimation>
                </FullWrapper>
            </ScrollAnimation>
        );
    }
}

export default Digits;
